var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.MyTeams.length > 0)?_vm._l((_vm.MyTeams),function(team){return _c('TeamMiniCard',{key:team.id,attrs:{"team":team},on:{"viewTeam":_vm.openTeamDashboard}})}):_c('p',{staticClass:"text-center"},[_vm._v("You don't have any teams setup yet.")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }